export const mobileRegex: RegExp =  /^\d{6,15}$/;

export const emailRegex: RegExp = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

export const passwordRegex: RegExp =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).{8,20}$/;

export const alphabetsRegex: RegExp = /^[a-zA-Z]+$/;

export const numberRegex: RegExp = /^[0-9]+$/;
// Or if you want to allow empty input (e.g., while typing): /^[0-9]*$/

export const floatingPointNumberRegex: RegExp = /^(?:[0-9]+(?:\.[0-9]*)?|\.[0-9]+)$/;

export const zipCodeRegex: RegExp = /^[A-Za-z0-9\s-]{3,10}$/;
